import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Heading, Paragraph } from '@digdir/designsystemet-react';
import { PageProblem } from '../../components/PageProblem';
import { ApiErrorUtils } from '../../utils/api-error.utils';
import layout from '../HRDashboard/hmsPage.module.css';

export type LoadSubject = 'round' | 'plan' | 'checklist';

/**
 * Why a safety round page could not be shown. Without access, or for what does not exist (also another organization's
 * id, or an organization without the module), the page says so plainly. Only other failures ask the user to try again.
 */
export const LoadProblem = ({ error, subject }: { error: unknown; subject?: LoadSubject }): ReactElement => {
  const { t } = useTranslation();
  const problem = ApiErrorUtils.pageProblemOf(error);
  if (problem === 'noAccess') return <PageProblem kind="noAccess" />;
  if (problem === 'notFound')
    return subject ? (
      <PageProblem
        kind="notFound"
        title={t(`safetyRounds.errors.notFound.${subject}.title`)}
        message={t(`safetyRounds.errors.notFound.${subject}.message`)}
      />
    ) : (
      <PageProblem kind="notFound" />
    );
  return (
    <div className={layout.loading}>
      <Alert data-color="danger">
        <Heading level={2} data-size="2xs">
          {t('safetyRounds.errors.loadTitle')}
        </Heading>
        <Paragraph>{t('safetyRounds.errors.loadMessage')}</Paragraph>
      </Alert>
    </div>
  );
};
